module.exports = import("https://cdn.skypack.dev/spltjs@1.0.8");;